export default "__VITE_ASSET__DFq1Son5__"